import { render, staticRenderFns } from "./TedsLauncherIconMenu.vue?vue&type=template&id=960cbcde&"
import script from "./TedsLauncherIconMenu.vue?vue&type=script&lang=ts&"
export * from "./TedsLauncherIconMenu.vue?vue&type=script&lang=ts&"
import style0 from "./TedsLauncherIconMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports